export default {
  input: {
    paddingTop: "12px",
    paddingBottom: "12px",
  },
};
